import React, { useState } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import AdminLayout from './AdminLayout'
import PlatosManager from './PlatosManager'
import MenuCloner from './MenuCloner'
import CSVUploader from './CSVUploader'
import MenuConfig from './MenuConfig'

const AdminDashboard = () => {
  return (
    <AdminLayout>
      <Routes>
        <Route path="/" element={<Navigate to="/admin/dashboard" replace />} />
        <Route path="/dashboard" element={<PlatosManager />} />
        <Route path="/clone" element={<MenuCloner />} />
        <Route path="/upload" element={<CSVUploader />} />
        <Route path="/config" element={<MenuConfig />} />
      </Routes>
    </AdminLayout>
  )
}

export default AdminDashboard